module.exports = __webpack_public_path__ + "site/img/sendfileen.54ca8b64.png";